const B = process.env.PUBLIC_URL;

export const completedProjects = [
  {
    id: "cp1",
    type: "Apartment",
    title: "Arthenian Emerald",
    location: "Koromila 5, Athens",
    year: "2025",
    area: "",
    client: "Private",
    cover: B + "/images/cp_emerald_1.jpg",
    gallery: [
      B + "/images/cp_emerald_1.jpg",
      B + "/images/cp_emerald_2.jpg",
      B + "/images/cp_emerald_3.jpg",
      B + "/images/cp_emerald_4.jpg",
      B + "/images/cp_emerald_5.jpg",
      B + "/images/cp_emerald_6.jpg",
      B + "/images/cp_emerald_7.jpg",
      B + "/images/cp_emerald_8.jpg",
      B + "/images/cp_emerald_9.jpg",
      B + "/images/cp_emerald_10.jpg",
      B + "/images/cp_emerald_11.jpg",
    ],
    desc: "A refined Airbnb apartment on Koromila Street, Athens. Designed with warm tones, quality furnishings and every detail considered for a premium short-stay experience.",
    features: ["Fully Furnished", "Premium Finishes", "Airbnb Ready", "Smart TV", "A/C"],
  },
  {
    id: "cp2",
    type: "Apartment",
    title: "Athenian Nook",
    location: "Koromila 5, Athens",
    year: "2025",
    area: "",
    client: "Private",
    cover: B + "/images/cp_nook_1.jpg",
    gallery: [
      B + "/images/cp_nook_1.jpg",
      B + "/images/cp_nook_2.jpg",
      B + "/images/cp_nook_3.jpg",
      B + "/images/cp_nook_4.jpg",
      B + "/images/cp_nook_5.jpg",
      B + "/images/cp_nook_6.jpg",
      B + "/images/cp_nook_7.jpg",
      B + "/images/cp_nook_8.jpg",
      B + "/images/cp_nook_9.jpg",
      B + "/images/cp_nook_10.jpg",
      B + "/images/cp_nook_11.jpg",
    ],
    desc: "A cosy, thoughtfully designed Airbnb apartment on Koromila Street. Compact and elegant — every square metre used with purpose.",
    features: ["Fully Furnished", "Compact Design", "Airbnb Ready", "A/C", "WiFi"],
  },
  {
    id: "cp3",
    type: "Apartment",
    title: "Athenian Rose Kipos",
    location: "Koromila 5, Athens",
    year: "2026",
    area: "",
    client: "Private",
    cover: B + "/images/cp_rose_1.jpg",
    gallery: [
      B + "/images/cp_rose_1.jpg",
      B + "/images/cp_rose_2.jpg",
      B + "/images/cp_rose_3.jpg",
      B + "/images/cp_rose_4.jpg",
      B + "/images/cp_rose_5.jpg",
      B + "/images/cp_rose_6.jpg",
      B + "/images/cp_rose_7.jpg",
      B + "/images/cp_rose_8.jpg",
      B + "/images/cp_rose_9.jpg",
      B + "/images/cp_rose_10.jpg",
      B + "/images/cp_rose_11.jpg",
    ],
    desc: "A ground-floor garden apartment with lush outdoor space — rare in central Athens. Professional photoshoot captured the serene, green atmosphere of this unique property.",
    features: ["Private Garden", "Ground Floor", "Outdoor Seating", "Airbnb Ready", "A/C"],
  },
  {
    id: "cp4",
    type: "Apartment",
    title: "Ireon 10 — Christodoulos & Emanouil",
    location: "Ireon 10, Athens",
    year: "2025",
    area: "",
    client: "Private",
    cover: B + "/images/cp_ireon_ce_1.jpg",
    gallery: [
      B + "/images/cp_ireon_ce_1.jpg",
      B + "/images/cp_ireon_ce_2.jpg",
      B + "/images/cp_ireon_ce_3.jpg",
      B + "/images/cp_ireon_ce_4.jpg",
    ],
    desc: "Professionally photographed short-term rental at Ireon 10 — a clean, modern interior with high-quality fixtures and a welcoming atmosphere for Airbnb guests.",
    features: ["Professional Photography", "Modern Interior", "Airbnb Ready", "Fully Furnished", "A/C"],
  },
  {
    id: "cp5",
    type: "Apartment",
    title: "Ireon 10",
    location: "Ireon 10, Athens",
    year: "2025",
    area: "",
    client: "Private",
    cover: B + "/images/cp_ireon_1.jpg",
    gallery: [
      B + "/images/cp_ireon_1.jpg",
      B + "/images/cp_ireon_2.jpg",
      B + "/images/cp_ireon_3.jpg",
      B + "/images/cp_ireon_4.jpg",
      B + "/images/cp_ireon_5.jpg",
      B + "/images/cp_ireon_6.jpg",
      B + "/images/cp_ireon_7.jpg",
      B + "/images/cp_ireon_8.jpg",
      B + "/images/cp_ireon_9.jpg",
      B + "/images/cp_ireon_10.jpg",
    ],
    desc: "A well-appointed Airbnb apartment at Ireon 10, Athens. Furnished and styled for short-term rental with an oak bed frame feature and carefully selected pieces throughout.",
    features: ["Oak Furniture", "Fully Furnished", "Airbnb Ready", "Smart TV", "A/C"],
  },
  {
    id: "cp7",
    type: "Apartment",
    title: "Veikou 135",
    location: "Veikou 135, Athens",
    year: "2026",
    area: "",
    client: "Private",
    cover: B + "/images/cp_veikou_1.jpg",
    gallery: [
      B + "/images/cp_veikou_1.jpg",
      B + "/images/cp_veikou_2.jpg",
      B + "/images/cp_veikou_3.jpg",
      B + "/images/cp_veikou_4.jpg",
      B + "/images/cp_veikou_5.jpg",
      B + "/images/cp_veikou_6.jpg",
      B + "/images/cp_veikou_7.jpg",
      B + "/images/cp_veikou_8.jpg",
    ],
    desc: "A freshly completed Airbnb apartment on Veikou Street, Athens — styled and photographed ready for guests. Clean, modern and fully equipped.",
    features: ["Newly Completed", "Fully Furnished", "Airbnb Ready", "Modern Kitchen", "A/C"],
  },
  {
    id: "cp8",
    type: "Apartment",
    title: "Xatzopoulou 43",
    location: "Xatzopoulou 43, Athens",
    year: "2024",
    area: "",
    client: "Private",
    cover: B + "/images/cp_xatz_1.jpg",
    gallery: [
      B + "/images/cp_xatz_1.jpg",
      B + "/images/cp_xatz_2.jpg",
      B + "/images/cp_xatz_3.jpg",
      B + "/images/cp_xatz_4.jpg",
      B + "/images/cp_xatz_5.jpg",
      B + "/images/cp_xatz_6.jpg",
      B + "/images/cp_xatz_7.jpg",
      B + "/images/cp_xatz_8.jpg",
      B + "/images/cp_xatz_9.jpg",
      B + "/images/cp_xatz_10.jpg",
      B + "/images/cp_xatz_11.jpg",
      B + "/images/cp_xatz_12.jpg",
    ],
    desc: "A beautifully styled Airbnb apartment captured with professional HDR photography. Brand-new finishes, a quiet neighbourhood and everything a guest could need.",
    features: ["Brand New", "Professional Photography", "Quiet Street", "Fully Furnished", "A/C"],
  },
];
